import { API_PRECOG_URL_V1, API_VAT_REGISTRY_URL } from "../../../../config";
import { callWithRetry } from "../../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../../services/http-header";

export const vatSettlementConstants = {
  VATSETTLEMENT_READ_START: "VATSETTLEMENT_READ_START",
  VATSETTLEMENT_READ_SUCCESS: "VATSETTLEMENT_READ_SUCCESS",
  VATSETTLEMENT_READ_ERROR: "VATSETTLEMENT_READ_ERROR",
  VATSETTLEMENT_DETAILS_READ_START: "VATSETTLEMENT_DETAILS_READ_START",
  VATSETTLEMENT_DETAILS_READ_SUCCESS: "VATSETTLEMENT_DETAILS_READ_SUCCESS",
  VATSETTLEMENT_DETAILS_READ_ERROR: "VATSETTLEMENT_DETAILS_READ_ERROR",
  WORKSPACE_SETTLEMENT_READ_START: "WORKSPACE_SETTLEMENT_READ_START",
  WORKSPACE_SETTLEMENT_READ_SUCCESS: "WORKSPACE_SETTLEMENT_READ_SUCCESS",
  WORKSPACE_SETTLEMENT_READ_ERROR: "WORKSPACE_SETTLEMENT_READ_ERROR",
  VATSETTLEMENT_RATES_READ_START: "VATSETTLEMENT_RATES_READ_START",
  VATSETTLEMENT_RATES_READ_SUCCESS: "VATSETTLEMENT_RATES_READ_SUCCESS",
  VATSETTLEMENT_RATES_READ_ERROR: "VATSETTLEMENT_RATES_READ_ERROR",
  VATSETTLEMENT_CLOSE_PERIOD_START: "VATSETTLEMENT_CLOSE_PERIOD_START",
  VATSETTLEMENT_CLOSE_PERIOD_SUCCESS: "VATSETTLEMENT_CLOSE_PERIOD_SUCCESS",
  VATSETTLEMENT_CLOSE_PERIOD_ERROR: "VATSETTLEMENT_CLOSE_PERIOD_ERROR",
  VATSETTLEMENT_OPEN_PERIOD_START: "VATSETTLEMENT_OPEN_PERIOD_START",
  VATSETTLEMENT_OPEN_PERIOD_SUCCESS: "VATSETTLEMENT_OPEN_PERIOD_SUCCESS",
  VATSETTLEMENT_OPEN_PERIOD_ERROR: "VATSETTLEMENT_OPEN_PERIOD_ERROR",

  CLEAR_VATSETTLEMENT_DETAILS_DATA: "CLEAR_VATSETTLEMENT_DETAILS_DATA"
};

export const clearVatSettlementDetailsData = () => {
  return dispatch => {
    dispatch({
      type: vatSettlementConstants.CLEAR_VATSETTLEMENT_DETAILS_DATA
    });
  };
};

export const getVatSettlement = (
  businessId,
  refYear,
  periodRef
) => {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const main = getState().main;

    return new Promise((resolve, reject) => {
      const parameters = {
        refYear: refYear,
        periodRef: periodRef,
        businessId: businessId,
        model: "vatSettlement"
      };

      dispatch({
        type: vatSettlementConstants.VATSETTLEMENT_READ_START,
        payload: { parameters: parameters }
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/vat/businesses/${businessId}/settlements?itemId=${main.companyUuidSelected}&managerId=${main.accountantUuidSelected}&year=${refYear}&ordinal=${periodRef.toUpperCase()}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_READ_SUCCESS,
            payload: { data: result.data, parameters: parameters }
          });
          resolve(result.data);
        })
        .catch(err => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_READ_ERROR,
            payload: err
          });
          reject(err);
        });
    });
  };
};

export const closeVatSettlement = (
  businessId,
  year,
  ordinal
) => {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const main = getState().main;

    return new Promise((resolve, reject) => {
      const parameters = {
        businessId,
        year,
        ordinal
      };

      dispatch({
        type: vatSettlementConstants.VATSETTLEMENT_CLOSE_PERIOD_START,
        payload: { parameters: parameters }
      });

      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/vat/settlements/close`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {
          itemId:main.companyUuidSelected,
          managerId: main.accountantUuidSelected,
          businessPeriods: {
            [businessId]: {
              year,
              ordinal
            }
          }
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_CLOSE_PERIOD_SUCCESS,
            payload: { data: result.data, parameters: parameters }
          });
          resolve(result.data);
        })
        .catch(err => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_CLOSE_PERIOD_ERROR,
            payload: err
          });
          reject(err);
        });
    });
  };
};

export const openVatSettlement = (
  settlementId, year, ordinal
) => {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const main = getState().main;

    return new Promise((resolve, reject) => {      

      dispatch({
        type: vatSettlementConstants.VATSETTLEMENT_OPEN_PERIOD_START
      });

      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/vat/settlements/open`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {
          itemId:main.companyUuidSelected,
          managerId: main.accountantUuidSelected,
          businessPeriods: {
            [settlementId]: {
              year,
              ordinal
            }
          }          
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_OPEN_PERIOD_SUCCESS,
            payload: settlementId
          });
          resolve(result.data);
        })
        .catch(err => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_OPEN_PERIOD_ERROR,
            payload: err
          });
          reject(err);
        });
    }, 1500);
  };
};

export const getVatSettlementRates = () => {
  return (dispatch, getState) => {

    const auth = getState().auth;

    return new Promise((resolve, reject) => {
      dispatch({
        type: vatSettlementConstants.VATSETTLEMENT_RATES_READ_START
      });

      let request = {
        method: "GET",
        url: `${API_VAT_REGISTRY_URL}/enums/vat-rates`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_RATES_READ_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch(err => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_RATES_READ_ERROR,
            payload: err
          });
          reject(err);
        });
    });
  };
};

export const getWorkspaceSettlement = (refYear,
  periodRef) => {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const main = getState().main;

    return new Promise((resolve, reject) => {
      const parameters = {
        refYear: refYear,
        periodRef: periodRef,
        model: "vatSettlement"
      };

      dispatch({
        type: vatSettlementConstants.WORKSPACE_SETTLEMENT_READ_START,
        payload: { parameters: parameters }
      });
      let url = `${API_PRECOG_URL_V1}/vat/settlements?managerId=${main.accountantUuidSelected}&itemId=${main.companyUuidSelected}&year=${refYear}`;
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: vatSettlementConstants.WORKSPACE_SETTLEMENT_READ_SUCCESS,
            payload: { data: result.data, parameters: parameters }
          });
          resolve(result.data);
        })
        .catch(err => {
          dispatch({
            type: vatSettlementConstants.WORKSPACE_SETTLEMENT_READ_ERROR,
            payload: err
          });
          reject(err);
        });
    }, 1500);
  };
};

export const getVatSettlemenDetails = (
  businessId,
  refYear,
  periodRef,
  vatCode,
  journalType,
  sectional
) => {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;

    let url = `${API_PRECOG_URL_V1}/vat/businesses/vat-entries?managerId=${main.accountantUuidSelected}&itemId=${main.companyUuidSelected}&year=${refYear}&ordinal=${periodRef}`;
    if (journalType) {
      url = url + `&journalType=${journalType}`;
    }
    if (vatCode) {
      url = url + `&vatCode=${vatCode}`;
    }
    if (sectional) {
      url = url + `&sectional=${sectional}`;
    }
    if (businessId) {
      url = url + `&businessId=${businessId}`;
    }

    return new Promise((resolve, reject) => {

      dispatch({
        type: vatSettlementConstants.VATSETTLEMENT_DETAILS_READ_START
      });

      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_DETAILS_READ_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch(err => {
          dispatch({
            type: vatSettlementConstants.VATSETTLEMENT_DETAILS_READ_ERROR,
            payload: err
          });
          reject(err);
        });
    }, 1500);
  };
};
